import { type GuideButtonContent } from "../types";

export function normalizeButtonContent(
  button?: GuideButtonContent
): GuideButtonContent | undefined {
  const text = button?.text?.trim();
  const action = button?.action?.trim();
  if (!text || !action) {
    return undefined;
  }

  return { text, action };
}
